import React from "react";
import { CheckCircle2, AlertCircle, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { getConfidenceBadgeClass } from "../../utils/helpers";
import { getVisitTypeDisplay } from "./visitHelpers";

export const PendingVisitsTable = ({ pendingVisits, onReview, onReject }) => {
  if (!pendingVisits.length) return null;
  return (
    <Card className="border-0 shadow-lg border-orange-200" data-testid="pending-visits-table">
      <CardHeader className="bg-orange-50">
        <CardTitle className="text-orange-800 flex items-center gap-2">
          <AlertCircle className="h-5 w-5" /> Pending Visit Validations ({pendingVisits.length})
        </CardTitle>
        <CardDescription className="text-orange-600">These visits need manual review and approval before tasks can be created</CardDescription>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-orange-100">
              <tr>
                <th className="text-left p-4 font-semibold text-orange-800">Email Subject</th>
                <th className="text-left p-4 font-semibold text-orange-800">PI Name</th>
                <th className="text-left p-4 font-semibold text-orange-800">Study Info</th>
                <th className="text-left p-4 font-semibold text-orange-800">Visit Type</th>
                <th className="text-left p-4 font-semibold text-orange-800">Patient</th>
                <th className="text-left p-4 font-semibold text-orange-800">Matched Site</th>
                <th className="text-left p-4 font-semibold text-orange-800">Confidence</th>
                <th className="text-left p-4 font-semibold text-orange-800">Actions</th>
              </tr>
            </thead>
            <tbody>
              {pendingVisits.map((pv, idx) => (
                <tr key={pv.id} className={`border-b hover:bg-orange-25 ${idx % 2 === 0 ? 'bg-white' : 'bg-orange-25'}`}>
                  <td className="p-4 font-medium text-gray-900">{pv.email_subject}</td>
                  <td className="p-4 text-gray-600">{pv.parsed_data?.pi_name}</td>
                  <td className="p-4 text-gray-600">{pv.parsed_data?.study_info}</td>
                  <td className="p-4">
                    <Badge variant="outline" className="bg-blue-100 text-blue-800">{getVisitTypeDisplay(pv.parsed_data?.visit_type)}</Badge>
                  </td>
                  <td className="p-4 text-gray-600">{pv.parsed_data?.patient_name}</td>
                  <td className="p-4 text-gray-600">{pv.matched_site ? pv.matched_site.name : 'No match'}</td>
                  <td className="p-4">
                    <Badge className={getConfidenceBadgeClass(pv.confidence_score)}>
                      {(pv.confidence_score * 100).toFixed(0)}%
                    </Badge>
                  </td>
                  <td className="p-4">
                    <div className="flex gap-2">
                      <Button size="sm" variant="outline" onClick={() => onReview(pv)} className="text-green-600 hover:text-green-700 hover:bg-green-50" data-testid={`review-pending-${pv.id}`}>
                        <CheckCircle2 className="h-3 w-3 mr-1" /> Review
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => onReject(pv.id)} className="text-red-600 hover:text-red-700 hover:bg-red-50" data-testid={`reject-pending-${pv.id}`}>
                        <Trash2 className="h-3 w-3" />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
